<template>
  <n-modal
    v-model:show="loginModalVisible"
    :mask-closable="false"
    :closable="false"
    preset="dialog"
    width="100%"
    :showIcon="false"
    :close-on-esc="false"
    class="login-modal"
    contentClass="login-modal__content"
  >
    <div class="login-area flex">
      <div class="login-area__left w-320px">
        <img class="login-area__left-img" src="@/assets/img/login.png" alt="" />
      </div>

      <div class="login-area__right flex-1">
        <header class="flex justify-between items-center">
          <h2 class="text-[#1e1e1e] font-bold mb-30px">登录您的平台账号</h2>
          <div>
            没有账号？<el-button type="primary" text>点此注册</el-button>
          </div>
        </header>
        <div class="custom-tabs">
          <div
            class="custom-tabs__pane"
            @click="handleTab('phone')"
            :class="{
              'custom-tabs__pane--active': currentActiveName === 'phone'
            }"
          >
            验证码登录
          </div>
          <div
            @click="handleTab('account')"
            class="custom-tabs__pane"
            :class="{
              'custom-tabs__pane--active': currentActiveName === 'account'
            }"
          >
            帐号登录
          </div>
        </div>
        <HpForm
          ref="hpFormRef"
          :rules="rules"
          :form-items="formItems"
          v-model="formData"
        >
          <template #captchaCode="{ formData, formItem }">
            <customInput v-model="formData[formItem.path]" v-bind="formItem">
              <template #suffix
                ><img
                  class="captcha-img"
                  :src="currentCaptchaImg"
                  alt=""
                  @click="fetchCaptcha(currentActiveName)"
              /></template>
            </customInput>
          </template>
          <template #smsCode="{ formData, formItem }">
            <customInput v-model="formData[formItem.path]" v-bind="formItem">
              <template #suffix>
                <CustomButton
                  v-if="!active"
                  type="primary"
                  text
                  @click="fetchSmsCode"
                  >获取验证码</CustomButton
                >
                <n-countdown
                  v-if="active"
                  :duration="duration"
                  :active="active"
                  :on-finish="handleDuration"
                />
              </template>
            </customInput>
          </template>
        </HpForm>
        <div class="login-bottom">
          <div class="forget-password">
            <CustomButton
              text
              :padding="0"
              type="default"
              @click="handleForgetPassword"
            >
              忘记密码?
            </CustomButton>
          </div>
          <CustomButton
            @click="handleSubmit"
            round
            type="primary"
            block
            size="large"
          >
            登录
          </CustomButton>
          <div class="register-link flex justify-center items-center">
            登录注册及代表同意
            <CustomButton
              width="100px"
              text
              :padding="0"
              size="tiny"
              :isMargin="false"
            >
              《用户协议》
            </CustomButton>
            、
            <CustomButton
              width="100px"
              text
              :padding="0"
              size="tiny"
              :isMargin="false"
            >
              《隐私协议》
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  </n-modal>
</template>
<script lang="ts" setup>
import HpForm from '@/base-ui/hp-form'
import customInput from '@/base-ui/hp-form/src/components/customInput.vue'
import useLoginStore from '@/store/login/login'
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useLoginForm } from './config/login.config'
const loginStore = useLoginStore()
const router = useRouter()
const loginModalVisible = computed({
  get: () => loginStore.loginModalVisible,
  set: (val) => {
    loginStore.loginModalVisible = val
  }
})
const {
  hpFormRef,
  currentActiveName,
  rules,
  formData,
  formItems,
  currentCaptchaImg,
  fetchCaptcha,
  fetchSmsCode,
  active,
  duration,
  handleDuration,
  handleSubmit,
  handleTab
} = useLoginForm({
  loginStore
})

const handleForgetPassword = () => {
  loginStore.closeLoginModal()
  router.push('/reset-pass')
}

// 回车键登录
function handleEnterKeyDown(e: KeyboardEvent) {
  if (e.key === 'Enter') {
    e.preventDefault()
    handleSubmit()
  }
}
onMounted(() => {
  document.addEventListener('keydown', handleEnterKeyDown)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleEnterKeyDown)
})
</script>
<style lang="scss">
.login-modal {
  width: 800px !important;
  height: 485px !important;
  padding: 0 !important;
  border-radius: 10px;
  &__content {
    margin: 0 !important;
    height: 485px !important;
  }
  .login-area {
    height: 100%;
    .login-area__left-img {
      border-radius: 10px 0 0 10px;
      height: 100%;
      object-fit: cover;
    }
    .login-area__right {
      margin: 40px 50px 0;
    }
  }

  .login-form {
    margin: 0 auto;
  }
  .captcha-img {
    width: 100px;
    height: 36px;
    margin-left: 10px;
    cursor: pointer;
  }
}
.custom-tabs {
  width: 250px;
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px;
  gap: 0;
  background-color: #e5ecf9;
  border-radius: 10px;
  box-sizing: border-box;

  &__pane {
    flex: 1;
    height: 38px;
    line-height: 38px;
    padding: 0;
    cursor: pointer;
    text-align: center;
    background-color: transparent;
    border-radius: 8px;
    transition: all 0.2s ease;
    color: #bdbdbe;

    &--active {
      background-color: #fff;
      border-radius: 8px;
      font-weight: 600;
      color: #383838;
    }
  }
}
.login-bottom {
  margin-top: -10px;
  .forget-password {
    margin-bottom: 10px;
    text-align: right;
  }
  .register-link {
    margin-top: 10px;
    font-size: 12px;
    color: #909399;
    text-align: center;
    a {
      color: #2678ff;
    }
  }
}
</style>
